import type { IFieldError } from '@shared/model/types/dataResponse.inteface';

/** Возвращает null, если весь набор ошибок нельзя привязать к известным полям. */
export const mapApiErrorsToFields = <TField extends string>(
    errors: readonly IFieldError[],
    fieldByPointer: Readonly<Partial<Record<string, TField>>>
): Partial<Record<TField, string>> | null => {
    if (!Array.isArray(errors) || !errors.length) return null;

    let fieldErrors: Partial<Record<TField, string>> = {};
    const areAllErrorsMapped = errors.every((error) => {
        if (typeof error?.source?.pointer !== 'string' || typeof error?.title !== 'string') {
            return false;
        }

        const pointer = error.source.pointer.trim();
        const message = error.title.trim();
        if (!message || !Object.prototype.hasOwnProperty.call(fieldByPointer, pointer)) return false;

        const field = fieldByPointer[pointer];
        if (!field) return false;
        if (!Object.prototype.hasOwnProperty.call(fieldErrors, field)) {
            fieldErrors = { ...fieldErrors, [field]: message };
        }
        return true;
    });

    return areAllErrorsMapped ? fieldErrors : null;
};
